/**
 * MobileComingSoon — neutral stub for /m/* surfaces that don't have a
 * mobile-native page yet.
 *
 * Replaces the old "silent redirect to /m/tasks" anti-pattern (Spec P-04:
 * "Nothing routes to Tasks"). A user navigating to /m/schedule should see
 * a clear "coming soon" surface, not be teleported into a different list.
 */
import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'

export function MobileComingSoon() {
  const location = useLocation()
  const navigate = useNavigate()
  const label = location.pathname
    .replace(/^\/m\//, '')
    .replace(/[-/]/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase()) || 'This screen'

  return (
    <div
      style={{
        minHeight: 'calc(100dvh - 120px)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '32px 24px',
        textAlign: 'center',
        gap: 12,
      }}
    >
      <div
        style={{
          fontFamily: "'JetBrains Mono', ui-monospace, monospace",
          fontSize: 11,
          fontWeight: 600,
          letterSpacing: '0.14em',
          textTransform: 'uppercase',
          color: 'var(--text-muted)',
        }}
      >
        Coming soon
      </div>
      <h1
        style={{
          margin: 0,
          fontSize: 24,
          fontWeight: 700,
          letterSpacing: '-0.02em',
          color: 'var(--text-primary)',
        }}
      >
        {label}
      </h1>
      <p
        style={{
          margin: 0,
          maxWidth: 320,
          color: 'var(--text-secondary)',
          fontSize: 14,
          lineHeight: 1.5,
        }}
      >
        This surface isn&rsquo;t available on mobile yet. The desktop app has it
        if you need it now.
      </p>
      <button
        type="button"
        onClick={() => navigate('/m/tasks')}
        style={{
          marginTop: 8,
          display: 'inline-flex',
          alignItems: 'center',
          gap: 6,
          padding: '8px 14px',
          background: 'var(--bg-elevated)',
          color: 'var(--text-primary)',
          border: '1px solid var(--border)',
          borderRadius: 6,
          fontSize: 14,
          cursor: 'pointer',
        }}
      >
        <ArrowLeft size={14} />
        Back to Tasks
      </button>
    </div>
  )
}
